import ObjectiveSelector from '@/components/ObjectiveSelector';
import { ACTIONS } from '@/data/actions';
import { useUserObjectives } from '@/hooks/useUserObjectives';
import { useRouter } from 'expo-router';
import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';

export default function EditObjectivesScreen() {
  const router = useRouter();
  const { objectives, loading, updateObjectives } = useUserObjectives();

  const handleValidate = async (actionIds: number[]) => {
    const success = await updateObjectives(actionIds.length, actionIds);
    if (success) {
      router.back();
    }
  };

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#1C453F" />
      </View>
    );
  }

  return (
    <ObjectiveSelector 
      actions={ACTIONS} 
      onValidate={handleValidate}
      initialSelected={objectives?.selectedActionIds || []}
    />
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FBEFE3',
  },
});
